import clsx from "clsx";
import { FunctionComponent } from "react";
import { formatCount } from "./PageResultsCount";
import ThreatStatusLabel from "./ThreatStatusLabel";

const BRACKETS = {
  PARENTHESIS: {
    open: "(",
    close: ")"
  }
};

interface IClassificationCountersProps {
  className?: string;
  counts: Record<string, number>;
  urls?: Record<string, string>;
  brackets?: keyof typeof BRACKETS | "NONE";
}

const getLabel = (value: string, brackets?: keyof typeof BRACKETS | "NONE") => {
  if (!brackets || brackets === "NONE") return value;
  const { open, close } = BRACKETS[brackets ?? ""];
  if (!open || !close) return value;
  return `${open}${value}${close}`;
};

const ClassificationCounters: FunctionComponent<
  IClassificationCountersProps
> = ({ className, counts, urls, brackets = "PARENTHESIS" }) => (
  <div className={clsx("classification-counters", className)}>
    <span className="classification-counters__item">
      <ThreatStatusLabel
        threatStatus="malicious"
        showColor
        url={urls?.malicious}
        labelText={`${getLabel(
          formatCount(counts.malicious).toString(),
          brackets
        )}`}
      />
    </span>
    <span className="classification-counters__item">
      <ThreatStatusLabel
        threatStatus="suspicious"
        showColor
        url={urls?.suspicious}
        labelText={`${getLabel(
          formatCount(counts.suspicious).toString(),
          brackets
        )}`}
      />
    </span>
    {counts?.unknown !== undefined && (
      <span className="classification-counters__item">
        <ThreatStatusLabel
          threatStatus="unknown"
          showColor
          url={urls?.unknown}
          labelText={`${getLabel(
            formatCount(counts.unknown).toString(),
            brackets
          )}`}
        />
      </span>
    )}
    <span className="classification-counters__item">
      <ThreatStatusLabel
        threatStatus="known"
        showColor
        url={urls?.goodware}
        labelText={`${getLabel(
          formatCount(counts.goodware).toString(),
          brackets
        )}`}
      />
    </span>
  </div>
);

export default ClassificationCounters;
